export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-facebook-f6fb54a3892b4ac0945e577154d60228.svg";